import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import SettingsSuggestRoundedIcon from '@mui/icons-material/SettingsSuggestRounded';
import HubRoundedIcon from '@mui/icons-material/HubRounded';

export const expeditionBillingNavigationMenu = [
  {
    label: 'Expediciones pendientes',
    path: '/',
    icon: AssignmentRoundedIcon,
  },
  {
    label: 'Procesos de facturación',
    path: '/procesos',
    icon: ReceiptLongRoundedIcon,
  },
  {
    label: 'Configuración de facturación',
    path: '/configuracion',
    icon: SettingsSuggestRoundedIcon,
  },
  {
    label: 'Equivalencias del cliente',
    path: '/correspondencias',
    icon: HubRoundedIcon,
  },
];

export const expeditionBillingNavigationItems = expeditionBillingNavigationMenu;
